<template>
  <b-table
    sticky-header="200px"
    class="tablestyle"
    :no-border-collapse="noCollapse"
    :items="tableValue.items"
    :fields="tableValue.fields"
    head-variant="#6192b1"
    responsive="sm"
    style="max-height:300px; overflow:auto;"
    :filter="filter"
    :busy="tableLoading"
    show-empty
    empty-text="No Records Found"
  >
    <template v-slot:table-busy>
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong class="ml-2">Loading...</strong>
      </div>
    </template>
    <template slot="numberOfOrders" slot-scope="row">
      <span class="table-number ml-3">{{row.item.numberOfOrders}}</span>
    </template>
    <template class="p-0 m-0" v-slot:cell(startDate)="row">
      <!--span v-if="bidType == 'Bid'">
        <img v-if="bidStatus[row.index]" class="status-img" :src="getImage(bidStatus[row.index])" />
        <span :class="statusType(bidStatus[row.index])" class="ml-2">{{bidStatus[row.index]}}</span>
      </span>
      <span v-else>
        <img
          v-if="auctionStatus[row.index]"
          class="status-img"
          :src="getImage(auctionStatus[row.index])"
        />
        <span
          :class="statusType(auctionStatus[row.index])"
          class="ml-2"
        >{{auctionStatus[row.index]}}</span>
      </span>
      <br /-->
      <!--w-countdown
        @timer="bidTypes($event,row,i)"
        :starttime="dateFormat(row.item.startDate)"
        :endtime="dateFormat(row.item.endDate)"
        :currentIndex="row.index"
        :bidType="bidType"
      /-->
      <span style="white-space: nowrap;">
      <span v-html="getStatus(row.item.startDate, row.item.endDate)"></span><br>
      <span style="font-weight:bold;" v-if="isviewable(row.item.startDate, row.item.endDate) != 'Expired'">start:</span>
      <span v-if="isviewable(row.item.startDate, row.item.endDate) != 'Expired'"> {{dateFormat(row.item.startDate)}} </span>
      <br v-if="isviewable(row.item.startDate, row.item.endDate) != 'Expired'">
      <span style="font-weight:bold;" v-if="isviewable(row.item.startDate, row.item.endDate) != 'Expired'">End:</span>
      <span v-if="isviewable(row.item.startDate, row.item.endDate) != 'Expired'"> {{dateFormat(row.item.endDate)}} </span>
      </span>
    </template>
    <!-- <template class="p-0" v-slot:cell(status)="row">
      <span class="mr-1" :class="statusType(bidType)" @click="test(row.item)"></span>
    </template>-->
    <template v-slot:cell(endDate)="row">
      <p v-if="bidType == 'Bid'" class="viewDetails" @click="triggerDetails(row.item)">
        <!-- {{bidStatus}} {{row.index}} -->
        <b-button
          class="bid-button"
          v-if="isviewable(row.item.startDate, row.item.endDate) == 'Expired' || isviewable(row.item.startDate, row.item.endDate) == 'Upcoming'"
        >View Bid</b-button>
        <b-button class="bid-button" v-if="isviewable(row.item.startDate, row.item.endDate) == 'Live'">Place Bid</b-button>
      </p>
      <p v-else class="viewDetails" @click="triggerDetails(row.item)">
        <b-button
          class="bid-button"
          v-if="isviewable(row.item.startDate, row.item.endDate) == 'Expired' || isviewable(row.item.startDate, row.item.endDate) == 'Upcoming' "
        >View Auction</b-button>
        <b-button class="bid-button" v-if="isviewable(row.item.startDate, row.item.endDate) == 'Live'">Place Auction</b-button>
      </p>
    </template>
  </b-table>
</template>

<script>
import countDown from "./countdowntimer";
import moment from "moment";
import requireContext from 'require-context.macro';
export default {
  components: {
    "w-countdown": countDown
  },
  props: ["tableValue", "tableLoading", "bidType"],

  data() {
    return {
      itemValue: [],
      bidStatus: [],
      auctionStatus: []
    };
  },
  created() {
    // this.getItemValue();
  },
  filters: {
    remarksText: function(string) {
      return string.substring(0, 30) + "...";
    }
  },
  methods: {
    getStatus(start,end){
      if(new Date(end) < new Date()){
        return '<span style="color:#ff1800;font-size: 16px;">&#9673;&nbsp;Expired</span>'
      } else if (new Date(start) <= new Date() && new Date(end) >= new Date()){
        return '<span style="color:#1cda06;font-size: 16px;">&#9673;&nbsp;Live</span>'
      } else if (new Date(start) > new Date()){
        return '<span style="color:#0081f0;font-size: 16px;">&#9673;&nbsp;Upcoming</span>'
      }
    },

    
    isviewable(start,end){
      if(new Date(end) < new Date()){
        return 'Expired'
      } else if (new Date(start) <= new Date() && new Date(end) >= new Date()){
        return 'Live'
      } else if (new Date(start) > new Date()){
        return 'Upcoming'
      }
    },
    // getItemValue() {
    //   console.log(this.items);
    //   this.items.forEach(element => {
    //     if (element.RESPONSE === "Satisfied") {
    //     }
    //   });
    // }
    bidTypes(event, i) {
      // this.status.push(event);
      // console.log(this.status);
      if (event.bidType == "Bid") {
        this.bidStatus[event.index] = event.action;
        this.$forceUpdate();
        return this.bidStatus;
      } else {
        this.auctionStatus[event.index] = event.action;
        this.$forceUpdate();
        return this.auctionStatus;
      }
    },
    triggerDetails(bidDetails) {
      this.$emit("viewDetails", bidDetails);
    },
    dateFormat(date) {
      return moment(date).format("ll HH:mm:ss");
    },
    getImage(icon) { 
      var images = requireContext("@/assets/Icons/", false, /\.svg$/);
      return images("./" + icon + ".svg");
    },
    statusType(event) {
      if (event == "Expired") {
        return "dottedRejected";
      }
      if (event == "Live") {
        return "dottedGreen";
      }
      if (event == "Upcoming") {
        return "dottedPending";
      }
    },
    updateRating(value) {
      if (value > 75) {
        return "success";
      }
      if (value > 50 && value <= 75) {
        return "warning";
      }
      if (value <= 50 && value >= 40) {
        return "info";
      }
      if (value < 40) {
        return "danger";
      }
    }
  }
};
</script>

<style>
.thClassLeft {
  background-color: #6192b1 !important;
  color: white;
  text-align: left;
}

.table-value {
  text-align: left;
}
.table-number {
  text-align: right !important;
}
.tablestyle {
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px !important;
}
.viewDetails {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px !important;
  text-decoration: underline;
  cursor: pointer;
}
.dottedGreen {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px !important;
  font-weight: 600;
  color: #28b915;
}
.dottedPending {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px !important;
  font-weight: 600;
  color: #e89642;
}
.dottedRejected {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px !important;
  font-weight: 600;
  color: #e61313;
}
.status-img {
  width: 22px !important;
  height: 22px !important;
}
.bid-button {
  font-family: "Source Sans Pro", sans-serif;
  /* width: 80%; */
  border-radius: 3px;
  font-size: 0.8em;
  border: solid 1px #0c5e9d;
  background-color: #ffffff;
  color: #0c5e9d;
  font-weight: 600;
}
@media screen and (min-device-width: 1200px) and (max-device-width: 1400px) {
  .bid-button {
    font-size: 10px !important;
  }
}
</style>

